/**
 * DemoBanner - sticky teal strip shown on every authed page while
 * the visitor is in demo mode (flagged by localStorage on the "Try
 * full demo" flow). Renders nothing outside of demo mode.
 *
 * Copy calls out that (a) this is sample data from Helix Partners,
 * (b) their mutations won't stick, and (c) there's a cheap CTA to
 * sign up for real. Stays out of the way visually but never invisible.
 */

import { Link } from 'react-router-dom';
import { Eye, ArrowRight } from 'lucide-react';
import { isDemoSession, demoAIQueriesRemaining, DEMO_AI_CAP } from '@/lib/demo';

export function DemoBanner() {
  if (!isDemoSession()) return null;

  const remaining = demoAIQueriesRemaining();

  return (
    <div
      className="sticky top-0 z-50 bg-gradient-to-r from-primary-600 to-primary-700 text-white text-xs"
      role="status"
      aria-live="polite"
    >
      <div className="max-w-[1480px] mx-auto flex items-center justify-between gap-3 px-4 py-1.5 lg:px-6">
        <div className="flex items-center gap-2 min-w-0">
          <Eye className="w-3.5 h-3.5 shrink-0" />
          <span className="truncate">
            <strong>Demo session</strong> &middot; Helix Partners LLC sample data &middot; Changes reset nightly &middot; Ask Nexus: {remaining}/{DEMO_AI_CAP} queries left
          </span>
        </div>
        <Link
          to="/register"
          className="inline-flex items-center gap-1 rounded-md bg-white/15 hover:bg-white/25 px-2.5 py-1 font-medium shrink-0"
        >
          Sign up for real <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
}
